"use strict";

require("./_product-sticky-add-to-cart");